module.exports = __webpack_public_path__ + "img/Animal-Prints.14fc4ba8.jpg";